import {useRouter} from 'next/router';
import {extractPathSegments} from '../../../core/factories/clips/extractPathSegments';

type ColorUtilProps = {
  url: string;
};

export const usePageTabColors = ({url}: ColorUtilProps) => {
  const router = useRouter();
  const pathName = extractPathSegments(router.pathname)[0];
  const urlName = extractPathSegments(url)[0];
  const bgColor = pathName === urlName ? 'bg-transparent' : 'bg-disabled-1';
  const textColor = pathName === urlName ? 'text-link' : 'text-black-2';

  return {
    bgColor,
    textColor,
  };
};
